<template>
    <main
        id="page-my-account"
        class="bg-gray-100"
    >
        <div class="container mx-auto">
            <Breadcrumb/>
        </div>
        <section class="container mx-auto py-16 space-y-4">
            <div class="col-span-2">
                <h1 class="text-xl lg:text-5xl text-secondary uppercase">
                    Ansprechpartner
                </h1>
            </div>
        </section>
    </main>
</template>

<script setup lang="ts">
definePageMeta({
    path: '/ansprechpartner',
});
</script>
